"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var context_1 = require("./context");
var theme_1 = require("../../utils/theme");
function getTextOfStatus(message, status) {
    if (React.isValidElement(message) || typeof message === 'string') {
        return status === 'error' ? message : undefined;
    }
    if (typeof message === 'object') {
        return message[status];
    }
}
var Item = (function (_super) {
    tslib_1.__extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, status = _a.status, message = _a.message;
            var classes = classNames(prefixCls, className);
            var text = getTextOfStatus(message, status);
            var textClasses = classNames(prefixCls + "-text", prefixCls + "-text-" + status);
            return (h(context_1.FormItemContext.Provider, { value: { status: status } },
                h("div", { className: classes, style: style },
                    children,
                    text ?
                        h("div", { className: textClasses }, text)
                        : null)));
        };
        return _this;
    }
    Item.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Item;
}(React.Component));
exports.default = Item;
Item.defaultProps = {
    prefixCls: 'dui-m-form-item',
    status: 'default',
};
Item.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    status: PropTypes.oneOf(['default', 'success', 'error', 'warning']),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element])
};
